import {Component, OnInit, EventEmitter, NgModule} from '@angular/core';
import {Router} from '@angular/router';
import {LocalStorageManager} from 'src/app/data/manager/local-storage/local-storage.manager';
import {countryConfig} from 'src/country-config/country-config';
import {SupportVm} from 'src/app/view-model/support/support.vm';
import {HelpButtonOptions, HelpButtonOption, optionTypeEnum, HelpButtonDepartments} from './help-button.options';
import {Subscription} from 'rxjs/Subscription';

declare const zE: any;
declare let $zopim: any;

enum ChatDeparments{
  FARMACIA = 1,
  BELLEZA = 2,
  ATENCION_CLIENTE = 3,
  SOPORTE_DOMICILIO = 4

}

@Component({
  selector: 'app-help-button',
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss'],
})
export class HelpButtonComponent implements OnInit {
  public static buttonToggle: EventEmitter<any> = new EventEmitter();
  public static openChat: EventEmitter<any> = new EventEmitter();
  public static showSupport: EventEmitter<boolean> = new EventEmitter();
  public static onChatLogout: EventEmitter<any> = new EventEmitter();
  private _chat = false;
  hasLoaded = false;
  countryConfig = countryConfig;
  swZdWidget = false;
  public widget;
  modalStatus: any;
  modalNotificationsStatus: any;
  subscriptions: Subscription[] = [];

  changingOptions = false;
  currentOption: HelpButtonOption;

  set chat(state) {
    this._chat = state;
    if(!state) this.currentOption = HelpButtonOptions[0];
  }
  get chat() { return this._chat; }

  constructor(
    private router: Router,
    private supportVm: SupportVm,
    private lms: LocalStorageManager,
    private ssm: SessionStorageManager,
    private modalStatusEvent: UpdateSessionModalEvent,
    private notificationModalEvent: UpdateNotificationModalEvent
  ) {
   this.helpButtonInit();
  }

  private helpButtonInit() {
    this.currentOption = HelpButtonOptions[0];
    this.subscriptions.push(HelpButtonComponent.onChatLogout.subscribe(() => this.chatLogout()));
    this.subscriptions.push(HelpButtonComponent.buttonToggle.subscribe(() => this.chat = !this.chat));
    this.subscriptions.push(HelpButtonComponent.showSupport.subscribe((sw: boolean) => this.chat = sw));
    this.subscriptions.push(this.supportVm.onScriptLoaded.subscribe(() => this.hasLoaded = true));
    this.subscriptions.push(HelpButtonComponent.openChat.subscribe((deparment) => this.setDeparmentChat(deparment)));
  }

  private setDeparmentChat(deparment: number) {
    if($zopim) {
      $zopim.livechat.window.toggle();
      $zopim.livechat.window.show();
      this.setUserInfo();
      switch(deparment) {
        case ChatDeparments.FARMACIA:
          $zopim.livechat.departments.setVisitorDepartment(HelpButtonDepartments.ASESORIA_FARMACEUTICA);
          break;
        case ChatDeparments.BELLEZA:
          $zopim.livechat.departments.setVisitorDepartment(HelpButtonDepartments.ASESORIA_DERMOCOSMETICA);
          break;
        case ChatDeparments.ATENCION_CLIENTE:
          $zopim.livechat.departments.setVisitorDepartment(HelpButtonDepartments.ATENCION_CLIENTE);
          break;
        case ChatDeparments.SOPORTE_DOMICILIO:
          $zopim.livechat.departments.setVisitorDepartment(HelpButtonDepartments.SOPORTE_DOMICILIO);
      }
    }
  }

  private setUserInfo() {
    if(this.user.firstName || this.user.lastName) {
      $zopim.livechat.setName(`${ (this.user.firstName) ?this.user.firstName: ''} ${(this.user.lastName)? this.user.lastName: ''}`);
      $zopim.livechat.setEmail(this.user.email);
    }
  }

  get user() { return this.lms.get('customer'); }

  get hasSession() { return !this.user.isAnonymous; }

  get hasNotification() { return this.supportVm.hasNotification; }

  get isChatActive() { return this.ssm.get('multiCountry')?.support?.chat; }

  ngOnInit() {
    this.widget = new Zendesk();
    this.widget.isOpen.subscribe((state: boolean) => this.swZdWidget = state);
  }

  initAuth() {
    if (this.user && this.user.email) {
      this.widget.login(`${this.user.firstName} ${this.user.lastName}`, this.user.email, this.user.phone);
    }
  }

  setOption(option: HelpButtonOption, back = false) {
    if(back && this.currentOption) {
      this.changeOption(this.currentOption.parent);
      return;
    }
    switch(option.optionType) {
      case optionTypeEnum.chat:
        this.openZdWidget();
        break;
      case optionTypeEnum.method:
        this[option.action]();
        break;
      case optionTypeEnum.link:
        this.chat = false;
        this.router.navigate([option.href]);
        break;
      case optionTypeEnum.list:
        this.changeOption({...option, parent: this.currentOption});
      break;
    }
  }

  optionHide(option: HelpButtonOption) {
    const chat = (option.optionType === optionTypeEnum.chat && !this.isChatActive);
    const Logged = (option.onlyLogged && !this.hasSession);
    const anonimus = (option.onlyAnonimus && this.hasSession);
    return option.hide || chat || Logged || anonimus;
  }

  changeOption(option: HelpButtonOption) {
    this.changingOptions = true;
    setTimeout(() => {
      this.currentOption = option;
      this.changingOptions = false;
    }, 300);
  }

  openZdWidget() {
    this.chat = false;
    this.widget.open();
    this.initAuth();
  }

  chatLogout() {
    this.widget.logout();
  }

  openSessionModal() {
    this.modalStatus = {open: true};
  }

  openSessionModalNotifications() {
    if(this.hasSession){
      this.notificationModalEvent.changeModalStatus( {open: true} );
    }else{
      this.modalStatusEvent.changeModalStatus( {open: true} );
      this.modalStatusEvent.changeModalOrigin( {notification: true} )
    }
  }

  payment() {
    this.openZdWidget();
    this.initAuth();
    if($zopim) {
      $zopim.livechat.departments.setVisitorDepartment('Soporte');
      $zopim.livechat.say('Buenas, tengo problemas con mi medio de pago.');
    }
  }

  openChat() { this.supportVm.openChat(); }

}

class Zendesk {
  isOpen: EventEmitter<any> = new EventEmitter();

  constructor() {
    this.loadScript().then(() => { this.loadEvents(); });
  }

  loadEvents() {
    const {default_department, departments} = zendeskConfig();
    try {
      if (zE) {
        zE('webWidget', 'setLocale', 'es');
        zE('webWidget:on', 'open', () => { this.isOpen.emit(true); });
        zE('webWidget:on', 'close', () => { this.isOpen.emit(false) });

        (window as any).zESettings = {
          webWidget: {
            chat: {
              departments: {
                enabled: departments,
                select: default_department || departments[0]
              }
            },
            contactOptions: {
              enabled: true,
              chatLabelOnline: {'*': 'Habla con nosotros'},
              chatLabelOffline: {'*': 'Chat no disponible'},
              contactFormLabel: {'*': 'Sugerencias o Reclamaciones'},
            },
            launcher: {
              chatLabel: {
                '*': 'Habla con nosotros',
              },
              mobile: {
                labelVisible: true,
              },
            },
            offset: {
              horizontal: '0px',
              vertical: '0px',
              mobile: {
                horizontal: '0px',
                vertical: '50px',
              },
            },
            label: {
              'es-ES': 'Habla con nosotros',
            },
          },
        };
      }
    } catch {
      setTimeout(() => this.loadEvents(), 500);
    }
  }

  loadScript() {
    return new Promise((resolve) => {
      try {
        if (zE) {
          resolve(true);
        }
      } catch (e) {
        ((d, s) => {
          const z: any = (c) => { z._.push(c); };
          const $$: any = z.s = d.createElement(s);
          const e = d.getElementsByTagName(s)[0];
          z.set = (o) => { z.set._.push(o); };
          z._ = [];
          z.set._ = [];
          $$.async = !0;
          $$.defer = !0;
          $$.setAttribute('charset', 'utf-8');
          $$.src = 'https://static.zdassets.com/ekr/snippet.js?key=7fc23b6b-3eb8-407c-a9d5-54ae47f2368f';
          $$.id = 'ze-snippet';
          z.t = + new Date();
          $$.type = 'text/javascript';
          e.parentNode.insertBefore($$, e);
          setTimeout(() => { resolve(true); }, 500);
        })(document, 'script');
      }
    });
  }

  open() {
    this.isOpen.emit(true);
    zE('webWidget', 'open')
  }

  login(name: string, email: string, phone: string) {
    zE('webWidget', 'prefill', {
      name: { value: name, readOnly: true },
      email: { value: email, readOnly: true },
      phone: { value: phone, readOnly: true }
    });
  }

  logout() {
    zE('webWidget', 'logout');
    zE('webWidget', 'hide');
  }
}

function zendeskConfig() : { default_department: string, departments:string[] } {
  const def = {
    departments: ['Asesoría Farmacéutica 24 horas Vzla'],
    default_department: 'Asesoría Farmacéutica 24 horas Vzla'
  };
  return JSON.parse(sessionStorage.multiCountry)?.zendesk || def;
}

import {CommonModule} from '@angular/common';
import {BasicModalModule} from '../modals/basic-modal/basic-modal.module';
import {ButtonModule} from '../button/button.module';
import {ResetPasswordModule} from '../../../modals/reset-password/reset-password.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IconsModule} from '../icons/icons.module';
import {SessionStorageManager} from 'src/app/data/manager/session-storage/session-storage.manager';
import {UpdateSessionModalEvent} from '../../event-listeners/update-session-modal/update-session-modal.event';
import {UpdateNotificationModalEvent} from '../../event-listeners/update-notification-modal/update-notification-modal.event';

@NgModule({
  declarations: [HelpButtonComponent],
  imports: [
    CommonModule,
    BasicModalModule,
    ButtonModule,
    ResetPasswordModule,
    FormsModule,
    ReactiveFormsModule,
    IconsModule,
  ],
})
export class HelpButtonModule { }
